import React from "react";
import Section from "../ui/Section";
import { contact, education, profile } from "../../data/profile";

function About() {
  const current = education[0];

  return (
    <Section
      id="about"
      eyebrow="About"
      title="Building software that turns data into decisions"
    >
      <div className="about">
        <div className="about__body">
          <p>
            I am a Computer Science and Engineering undergraduate at{" "}
            <strong>Haldia Institute of Technology</strong>, where I maintain a{" "}
            <strong>CGPA of 8.7</strong>. My work sits at the intersection of
            software development and applied machine learning.
          </p>
          <p>
            Most of what I build is practical: an emotion classifier that reads
            free text, a real-time dashboard that scores system health from live
            CPU and memory metrics, and a security-focused tool that surfaces
            risk signals. In each case the interesting part is not the model —
            it is shipping something someone can actually open and use.
          </p>
          <p>
            Alongside that I work on fundamentals — data structures and
            algorithms, operating systems, databases, and networks — and keep
            sharp through competitive programming. I am currently looking for
            internships where I can contribute to production systems and learn
            from engineers who have shipped at scale.
          </p>
        </div>

        <aside className="card">
          <ul className="info-list">
            <li className="info-list__row">
              <span className="info-list__label">Focus</span>
              <span>{profile.focus}</span>
            </li>
            <li className="info-list__row">
              <span className="info-list__label">Degree</span>
              <span>
                B.Tech CSE · {current.result.replace("CGPA: ", "CGPA ")}
              </span>
            </li>
            <li className="info-list__row">
              <span className="info-list__label">Institute</span>
              <span>{current.institution}</span>
            </li>
            <li className="info-list__row">
              <span className="info-list__label">Location</span>
              <span>{profile.location}</span>
            </li>
            <li className="info-list__row">
              <span className="info-list__label">Email</span>
              <a href={`mailto:${contact.email}`}>{contact.email}</a>
            </li>
          </ul>
        </aside>
      </div>
    </Section>
  );
}

export default About;
